<elder-basic-pane-layout class="full">
  <elder-pane class="flex-25">
    <elder-pane-subtitle>{{ 'properties.dynamic.title' | translate }}</elder-pane-subtitle>
    <elder-table
      class="flex"
      [data]="dynamicPropertyConfs$ | async"
      [idField]=""
      [elderTableActivation]="{}"
      [activeItem]="selectedConf$ | async"
      (activeItemChange)="selectedConf = $event"
      [selectionMultiEnabled]="false"
      [selectionVisible]="true"
      [interactionMode]="'selection'"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canMore]="false"
        [canAdd]="true"
        [canRemove]="true"
        (requestNew)="onNewSkillSet($event)"
        (requestRemove)="onRemoveSkillSets($event)"
      >
        <ng-template [elderToolbarContent]="'left'">
          <mat-form-field>
            <elder-select
              name="addDynamicProperty"
              placeholder="{{ 'context.add' | translate }}"
              [data]="_availableSpecs$ | async"
              [displayProperty]="'name'"
              (valueChange)="onNewSkillSet($event)"
              [value]="dummyValue"
            >
            </elder-select>
          </mat-form-field>
        </ng-template>
      </elder-data-toolbar>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ 'context.description' | translate }}</th>
        <td mat-cell *matCellDef="let conf">{{ conf?.description }}</td>
      </ng-container>

      <ng-container matColumnDef="specId">
        <th mat-header-cell *matHeaderCellDef>{{ 'context.specification' | translate }}</th>
        <td mat-cell *matCellDef="let conf">{{ conf?.spec?.name }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>

  <elder-pane>
    <app-dynamic-property-conf-detail class="flex" [conf]="selectedConf$ | async">
    </app-dynamic-property-conf-detail>
  </elder-pane>
</elder-basic-pane-layout>
